<template>
  <div class="zujian">
      <div class="map" >
        <div id="map"></div>
        <div class="detail" v-if="isDetail">
           <el-tabs v-model="activeName">
            <el-tab-pane label="行驶信息" name="gps">
              <div class="box1">
                 <div class="item"><span class="name">车牌号：</span><span>{{vehGps.plain}}</span></div>
                 <div class="item"><span  class="name">行驶状态：</span><span>{{vehGps.status}}</span></div>
                 <div class="item"><span  class="name">当前速度：</span><span>{{vehGps.speed}}KM/H</span></div>
                 <div class="item"><span  class="name">当前方向：</span><span> {{[ "北", "东北", "东", "东南", "南", "西南", "西", "西北" ][vehGps.fx-1]}}</span></div>
                 <div class="item"><span  class="name">总计里程：</span><span>{{vehGps.mileage ? vehGps.mileage : 0}}KM</span></div>
                 <div class="item"><span  class="name">设备ID：</span><span>{{vehGps.terminal_code}}</span></div>
                 <div class="item"><span  class="name">SIM卡号：</span><span>{{vehGps.sim}}</span></div>
                 <div class="item"><span  class="name">经度：</span><span>{{vehGps.longitude}}</span></div>
                 <div class="item"><span  class="name">纬度：</span><span>{{vehGps.latitude}}</span></div>
                  <div class="item item1"><span  class="name">上报时间：</span><span>{{vehGps.gps_time}}</span></div>
                 <div class="item item1"><span  class="name">当前位置：</span><span>{{vehGps.address}}</span></div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="close" @click="closeFn"><i class="el-icon-close"></i></div>
        </div>
        <div class="tuli">
          <div class="box2">
            <div class="item"><img src="../assets/vehMonitor/xingshi.png"><span>行驶</span></div>
            <div  class="item"><img src="../assets/vehMonitor/tingche.png"><span>停车</span></div>
            <!-- <div  class="item" v-if="mapData.type==1||mapData.type==3"><img style=" width: 32px;" src="../assets/vehMonitor/siji.png" ><span>司机</span></div> -->
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { direction, dateFormatUtil } from '@/utils/util'
import AMap from 'AMap'
import { vhcHisList, zjVhcHisList, cVehicleRealTimeGpsInfo, getCVehicleInfo, detailDriver } from '@/api/vehMonitor'
export default {
  name: 'mapReal',
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dateFormatUtil: dateFormatUtil,
      isDetail: false,
      isVeh: true,
      isDri: false,
      activeName: 'gps',
      timer: null,
      map: null,
      markers: [],
      vehInfo: null,
      vehGps: null,
      allGps: [],
      driInfo: '',
      driving: null,
      jht: []
    }
  },
  mounted () {
    this.initMap()
    // this.timer = setInterval(() => {
    //   this.getGps()
    // }, this.global.mapTime.waybillTime)

    // 路线规划
    // 显示起始终点 暂时注释掉 2023.04.26改
    // if (this.mapData.deliverLatitude && this.mapData.deliverLongitude && this.mapData.receivingLatitude && this.mapData.receivingLongitude) {
    //   let that = this
    //   // if (this.driving) {
    //   //   this.driving.clear()
    //   // }
    //   AMap.plugin('AMap.Driving', function () { })
    //   var drivingOption = {
    //     policy: 1,
    //     size: 4,
    //     // panel: 'panel',
    //     map: this.map
    //   }
    //   this.driving = new AMap.Driving(drivingOption) // 构造驾车导航类
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '正在处理...'
    //   })
    //   console.log(this.mapData)
    //   // let arr = []
    //   // arr.push({ lnglat: [this.mapData.deliverLongitude, this.mapData.deliverLatitude] })
    //   // arr.push({ lnglat: [this.mapData.receivingLongitude, this.mapData.receivingLatitude] })
    //   // console.log(arr[0], arr[1])
    //   // this.driving.search(new AMap.LngLat(116.379028, 39.865042), new AMap.LngLat(116.427281, 39.903719), function (status, result) {
    //   this.driving.search(new AMap.LngLat(this.mapData.deliverLongitude, this.mapData.deliverLatitude), new AMap.LngLat(this.mapData.receivingLongitude, this.mapData.receivingLatitude), function (status, result) {
    //     console.log(status, 'status')
    //     console.log(result, 'result')
    //     loading.close()
    //     if (status === 'complete' && result.info === 'OK') {
    //       result.routes.forEach(item => {
    //         that.drawRoute(item)
    //         that.searchFn()
    //       })
    //     } else {
    //       that.$alert('获取驾车数据失败', '系统提示')
    //     }
    //   })
    // }
    this.getGps()
  },
  methods: {
    searchFn () {
      // 查轨迹接口暂时注释掉  2023.04.26改
      // vhcHisList({ endTime: dateFormatUtil('yyyy-MM-dd hh:ii:ss', (new Date())), startTime: dateFormatUtil('yyyy-MM-dd hh:ii:ss', this.mapData.outTime), vchNo: this.mapData.vhcNo, serverName: '中物网络货运' }).then(res => {
      //   console.log(res)
      //   if (res) {
      //     this.lineArr = res.list

      //     if (this.lineArr.length > 0) {
      //       this.polylineFn()
      //       this.isDetail = true
      //     }

      //     // if (res.flag == 'vms') {
      //     //   this.loading = false
      //     //   this.gpsInfos = res.gpsInfos ? res.gpsInfos : []
      //     //   this.runTime = res.runTime
      //     // } else if (res.flag == 'hbase') {
      //     //   this.loading = false
      //     //   if (res.gpsInfos.length == 0) {
      //     //     zjVhcHisList(this.searchFrom).then(res1 => {
      //     //       this.gpsInfos = res1.gpsInfos
      //     //       this.runTime = res1.runTime
      //     //       this.loading = false
      //     //     })
      //     //   } else {
      //     //     this.gpsInfos = res.gpsInfos
      //     //     this.runTime = res.runTime
      //     //   }
      //     // } else {
      //     //   zjVhcHisList(this.searchFrom).then(res1 => {
      //     //     this.gpsInfos = res1.gpsInfos
      //     //     this.runTime = res1.runTime
      //     //     this.loading = false
      //     //   })
      //     // }
      //     if (this.lineArr.length > 0) {
      //       this.marker.moveAlong(this.lineArr, 800)
      //     }
      //   } else {
      //     this.$alert('当前车辆没有轨迹！', '系统提示')
      //   }
      // })
    },

    polylineFn () {
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lineArr[0],
        icon: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/cat.png',
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      // 绘制轨迹
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: this.lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      var passedPolyline = new AMap.Polyline({
        map: this.map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.marker.on('click', this.showInfoM)
      this.map.setFitView()
    },
    getVehInfo () {
      getCVehicleInfo({ vhcNo: this.mapData.vhcNo }).then(res => {
        this.vehInfo = res
        console.log(this.vehInfo)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error'
        })
      })
    },
    getGps () {
      this.allGps = []
      // if (this.mapData.isZJXL) {
      // cVehicleRealTimeGpsInfo({ vhcNo: '冀B06078D', serverName: '中物网络货运' }).then(res => {this.mapData.vhcNo
      cVehicleRealTimeGpsInfo({ vhcNo: this.mapData.vhcNo, serverName: '中物网络货运' }).then(res => {
        if (res) {
          this.vehGps = res
          if (this.vehGps.direction) {
            this.vehGps.fx = direction(this.vehGps.direction)
          }
          this.allGps.push(this.vehGps)
          // if (this.mapData.type == 1 || this.mapData.type == 3) { // 需要司机信息
          //   driverLastHis({ driverId: this.mapData.dirverId }).then(res => {
          //     if (res) {
          //       res.longitude = res.encryptLongitude
          //       res.latitude = res.encryptDimension
          //       res.plain = this.mapData.dirverName
          //       this.allGps.push(res)
          //     }
          this.markerFn(this.allGps)
          //   })
          // } else {
          //   this.markerFn(this.allGps)
          // }
        }
      })
      // }
      // else {
      //   // cVehicleGpsInfo({ vhcNo: this.mapData.vhcNo }).then(res => {
      //   cVehicleRealTimeGpsInfo({ vhcNo: '冀B02165D', serverName: '中物网络货运' }).then(res => {
      //     if (res) {
      //       this.vehGps = JSON.parse(res)
      //       if (this.vehGps.direction) {
      //         this.vehGps.fx = direction(this.vehGps.direction)
      //       }
      //       this.allGps.push(this.vehGps)
      //       if (this.mapData.type == 1 || this.mapData.type == 3) { // 需要司机信息
      //         driverLastHis({ driverId: this.mapData.dirverId }).then(res => {
      //           if (res) {
      //             res.longitude = res.encryptLongitude
      //             res.latitude = res.encryptDimension
      //             res.plain = this.mapData.dirverName
      //             this.allGps.push(res)
      //           }
      //           this.markerFn(this.allGps)
      //         })
      //       } else {
      //         this.markerFn(this.allGps)
      //       }
      //     }
      //   })
      // }
    },
    getDriInfo () {
      detailDriver({ id: this.mapData.dirverId }).then(res => {
        this.vehInfo = res
      })
    },
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
      this.map.setFitView()
    },
    markerFn (res) {
      this.map.clearMap()
      this.map.remove(this.markers)
      for (var i = 0; i < res.length; i += 1) {
        var marker
        let icon
        if (i == 0) {
          if (res[i].status == '行驶中') {
            icon = new AMap.Icon({
              image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/travel' + res[i].fx + '.png',
              size: new AMap.Size(36, 36)
            })
          } else {
            icon = new AMap.Icon({
              image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/parking' + res[i].fx + '.png',
              size: new AMap.Size(36, 36)
            })
          }
        } else {
          icon = new AMap.Icon({
            image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/vgs/monitor/siji.png',
            size: new AMap.Size(36, 36)
          })
        }

        let position = [res[i].longitude, res[i].latitude]
        marker = new AMap.Marker({
          icon: icon,
          position: position,
          offset: new AMap.Pixel(0, 0),
          zIndex: 101,
          title: res[i].plain,
          map: this.map
        })
        marker.on('click', this.showInfoM)
        this.markers.push(marker)
        this.map.setFitView()
      }
    },
    closeFn () {
      this.isDetail = false
    },
    showInfoM (e) {
      this.vehNo = e.target.w.title
      this.isDetail = true
    },
    drawRoute (route) {
      var path = parseRouteToPath(route)
      var routeLine = new AMap.Polyline({
        path: path,
        isOutline: false,
        outlineColor: '#ffeeee',
        borderWeight: 2,
        strokeWeight: 5,
        strokeColor: '#0091ff',
        lineJoin: 'round'
      })
      routeLine.setMap(this.map)
      // 调整视野达到最佳显示区域
      this.map.setFitView()
      function parseRouteToPath (route) {
        var path = []

        for (var i = 0, l = route.steps.length; i < l; i++) {
          var step = route.steps[i]

          for (var j = 0, n = step.path.length; j < n; j++) {
            path.push(step.path[j])
          }
        }

        return path
      }
    }
  },
  destroyed () {
    clearInterval(this.timer)
  }
}
</script>

<style scoped lang='less'>
.zujian{
  height: calc(100vh - 40px);
}
.map{
  width: 100%;
  height: 100%;
  position: relative;
}
.tuli{
  position: absolute;
  right: 0px;
  bottom: 0;
  background: #fff;
  z-index: 999999;
  border-radius: 10px 0px 0px 0px;
  padding: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box2{
    display: flex;
    .item{
      display: flex;
      width: 60px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      img{
        margin-bottom: 6px;

      }
    }
  }
  .hr{
    height: 26px;
    width: 0px;
    border-left:1px solid #ddd!important;
  }
}
.detail{
  position: absolute;
  right: 0px;
  top: 0;
  background: #fff;
  width: 400px;
  border-radius: 0px 0px 0px 10px;
  box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.9);
  .box1{
    display: flex;
    flex-wrap: wrap;
    .item{
      width: 45%;
      margin-right: 10px;
      padding:4px 0 ;
      display: flex;
    }
    .name{
      color:  #0c46a2;
      flex-shrink:0;
    }
    .item1{
      width: 100%;
    }
  }
  /deep/.el-tabs__item{
    font-size: 12px;
  }
  /deep/.el-tabs__nav{
    padding-left: 10px;
  }
  /deep/.el-tab-pane{
    padding: 0px 10px 15px;
    font-size: 12px;
  }
  /deep/.el-tabs__active-bar{
    left: 10px;
  }
  .close{
    height: 40px;
    position:absolute;
    top:0;
    right: 20px;
    display: flex;
    align-items: center;
  }
}
/deep/.el-main{
  padding-top:0 !important;
}
.cont{
  display: flex;
   height: calc(100% + 12px);
   margin-top: -12px;
}
.left{
  width: 200px;
  height: 100%;
  overflow: auto;
  flex-shrink: 0;
}
.right{
  flex: 1;
  height: 100%;
}
.tbale{
  height: 30%;
  font-size: 12px;
}
#map{
  width: 100%;
  height: 100%;
}
/deep/.el-tree-node__label{
  font-size: 12px;
}
</style>
